import { Link } from 'react-router-dom';

import { useFeatureFlags, useLanguage } from '../../hooks';
import { useUserDataStore } from '../../newStore/userDataStore';
import { paths } from '../../utils/navigation';
import { InformationBanner } from '../uiComponents/CommonComponents/InformationBanner';

interface OldLocationsWarningBannerProps {
  selectedMetadata: string;
}

export function OldLocationsWarningBanner({ selectedMetadata }: OldLocationsWarningBannerProps) {
  const hasAdminPermissions = useUserDataStore((state) => state.hasAdminRoleOnLocations());
  const lang = useLanguage();
  const { checkFlag } = useFeatureFlags();

  if (!checkFlag('NestableLocations') || selectedMetadata !== 'locations') {
    return null;
  }

  return (
    <div className='mb-4'>
      <InformationBanner
        message={
          <span>
            {lang.form_builder.oldLocationsListWarning}
            {hasAdminPermissions && (
              <Link
                target='_blank'
                rel='noopener noreferrer'
                to={paths.locations.createRoot}
                className='text-primary underline hover:text-primary/90 transition-colors'
              >
                {' '}
                {lang.locations.emptyState.createButton}
              </Link>
            )}
          </span>
        }
        type='info'
      />
    </div>
  );
}
